<app-breadcrumbs
  *ngIf="(selectedCategory$ | async)?.parents?.length"
  class="category-plp__breadcrumbs"
  [categories]="(selectedCategory$ | async).parents.slice().reverse()"
  [isDesktop]="commonProps.isDesktop"
>
</app-breadcrumbs>
<section>
  <div fxLayout="column">
    <ng-container
      *ngTemplateOutlet="
      (isSeoContentLoading$ | async) || commonProps.isLoading ? catalogLoading : productsListPage"
    ></ng-container>
    <ng-template #catalogLoading>
      <app-category-plp-loading
        [isMobile]="commonProps.isMobile"
        [isTablet]="commonProps.isTablet"
        [isDesktop]="commonProps.isDesktop"
        [isLandScapeTablet]="commonProps.isLandScapeTablet"
      >
      </app-category-plp-loading>
      <app-catalog-loading
        [isMobile]="commonProps.isMobile"
        [isTablet]="commonProps.isTablet"
        [isDesktop]="commonProps.isDesktop"
        [isLandScapeTablet]="commonProps.isLandScapeTablet"
      >
      </app-catalog-loading>
    </ng-template>
    <ng-template #productsListPage>
      <ng-container *ngTemplateOutlet="!!story ? dynamicCatalog : staticCatalog"> </ng-container>
    </ng-template>
  </div>

  <ng-template #dynamicCatalog>
    <!-- Storyblok dynamic components -->
    <div *ngIf="storyblokContent.length">
      <div *ngFor="let blok of storyblokContent" [appStoryblokEditable]="blok._editable">
        <ndc-dynamic [ndcDynamicComponent]="components[blok.component]" [ndcDynamicInputs]="buildInputs(blok)"> </ndc-dynamic>
      </div>
    </div>
  </ng-template>

  <ng-template #staticCatalog>
    <div class="category-plp">
      <div fxLayout="column">
        <app-catalog-products-list
          [searchQuery]="commonProps.searchQuery"
          [products]="commonProps.products"
          [totalCount]="commonProps.productsTotalCount"
          [recommendedProducts]="commonProps.recommendedProducts"
          [recommendedProductsType]="commonProps.recommendedProductsType"
          [isCategoryPage]="true"
          [selectedCategory]="selectedCategory$ | async"
          [queryParams]="commonProps.queryParams"
          [isMobileOrTablet]="commonProps.isMobileOrTablet"
          [isDesktop]="commonProps.isDesktop"
          [isMobile]="commonProps.isMobile"
          [isZeroResult]="commonProps.isZeroResult"
          [hasFilters]="commonProps.hasFilters"
          [isExpired]="commonProps.isExpired"
          [isTablet]="commonProps.isTablet"
        ></app-catalog-products-list>
      </div>
    </div>
  </ng-template>
</section>
